{
  "Clear search": "検索をクリア"
}
